import { Theme, colorGradients } from './theme-types'

const primary = "#53629E" // "#3182CE"
const dark = "#222222"

const lightTheme: Theme = {
  name: 'light',
  dark: false,
  colors: {
    primary: primary,

    // background colors
    bgMain: "#ffffff",
    bgSecond: "#F5F5F5",
    bgAlt: '#d0d0d0',

    // button colors
    buttonAlt: '#459BA0',

    // text colors
    textMain: '#292929',
    textSecond: '#454545',
    textAlt: '#aaa',
    placeholder: '#aaaaaa',

    // state colors
    success: "#1DCC70",
    danger: "#FF396F",
    warning: "#FFB400",
    info: "#05D0A4",
    disabled: "#D2D2D2",

    // border colors
    borderColor: "#DCDCE9",
    shadowColor: "#171717", // Keep current shadow for light mode
    // transactions
    bgTransaction: "#ffffff",

    // navigation
    statusBarStyle: 'dark',
    tabBackground: '#ffffff',
    tabInactiveText: '#A6A6A6',
    tabActiveText: primary,
    headerBackground: primary,
    headerText: '#ffffff',
    footerBackground: primary,

    // loading animation colors
    loadingAnimation: {
      color1: colorGradients.gray[700],
      color2: primary,
      color3: colorGradients.gray[700],
    },
    skeletonLoader: '#E6E8EC',

    // scrollbar colors
    scrollbarThumb: '#707070',

    // extra palette colors
    second: "#8494A8",
    dark: dark,
    darkAccent: "#002150",
    lightAccent: "#8a97d2",
    white: '#ffffff',
    ...colorGradients,
  },
}

export default lightTheme
